import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import Strings from "../globalization/pt-br/contact.json";

export const ContactPage: React.FC = () => {
    return (
        <>
            <h1>{Strings.title}</h1>
            <p dangerouslySetInnerHTML={{ __html: Strings.content }} />
        </>
    );
}